import { Component, OnDestroy, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { StateService } from '@uirouter/angular';
import { Subscription } from 'rxjs';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { JobService } from 'src/app/core/services/job.service';
import { ShellService } from 'src/app/core/services/shell.service';
import { StateManagementStorageService } from 'src/app/core/services/state-management-storage.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { UibModalService } from 'src/app/core/services/uibModalService';
import { UserService } from 'src/app/core/services/user.service';
import { WebSocketsService } from 'src/app/core/services/web-sockets.service';
import { IMAGE_URL, MESSAGECONSTANTS } from 'src/app/core/utils/constants';
import { BsModalService } from 'ngx-bootstrap';

declare var $: any;
declare var bootbox: any;

const STATES_WITH_DATA = [
  'missioncontrol.usermanagement',
  'missioncontrol.companymanagement',
  'missioncontrol.clientorbu',
  'missioncontrol.uploadreq',
  'missioncontrol.roleentityscope',
  'missioncontrol.settings',
  'missioncontrol.notificationpreference',
  'missioncontrol.editSharedReq'
];

@Component({
  selector: 'app-user-header',
  templateUrl: './user-header.component.html',
  styleUrls: ['./user-header.component.css']
})
export class UserHeaderComponent implements OnInit, OnDestroy {

  MESSAGECONSTANTS = MESSAGECONSTANTS;
  userDetails: any;
  imageUrl = IMAGE_URL;
  searchObject: any;
  userNotificationControls: any;
  isNotificationClicked = false;
  numberOfNewNotifications = 0;
  salaryDurationOptions: any;
  jobTypeList: any;
  private userDetailsSubscription: Subscription;
  private logoutSubscription: Subscription;

  constructor(
    private $state: StateService,
    private bsModalService: BsModalService,
    private companyService: CompanyService,
    private webSocketsService: WebSocketsService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private authService: AuthService,
    private userService: UserService,
    private StorageService: StorageService,
    private stateManagementStorageService: StateManagementStorageService,
    private uibModalService: UibModalService,
    private jobService: JobService,
    private shellService: ShellService
  ) { }

  get showNotificationsIcon(): boolean {
    return this.shellService.showNotificationsIcon;
  }

  get isFourDotFiveUser(): boolean {
    const roleName = _.get(this.userDetails, 'roleScreenRef.role.name');
    return roleName === '4dot5SuperUser' || roleName === '4dot5Admin';
  }

  get roleId(): string {
    return _.get(this.userDetails, 'roleScreenRef.role.id');
  }

  get fullName(): string {
    if (!this.userDetails) {
      return undefined;
    }
    return this.userDetails.lastname !== null
      ? this.userDetails.firstname + ' ' + this.userDetails.lastname
      : this.userDetails.firstname;
  }

  ngOnInit() {
    this.shellService.showNotificationsIcon = true;
    this.userDetails = _.cloneDeep(this.StorageService.get('userDetails'));
    this.searchObject = {
      page: 1,
      size: 20,
      companyId: this.authService.userDetails.company.companyId,
      notifyOn: 'GLOBAL'
    };
    this.userNotificationControls = {
      setNewNotificationsAsViewed: null,
      notificationClickCount: 0
    };

    if (this.authService.userDetails) {
      this.companyService.getCompanyDetails(this.authService.userDetails.company.companyId, (data) => {
        this.authService.userDetails.company.companyState = data.companyState;
        this.companyService.setCompanyStateLabel();
      }, () => { });
    }

    this.syncUserDetails();
    this.userDetailsSubscription = this.authService.userDetailsChanged.subscribe(() => this.syncUserDetails());

    this.logoutSubscription = this.authService.logoutRequested.subscribe((data) => {
      this.logout(data);
    });

    $(window).smartresize(() => {
      if ($(document).width() < 991) {
        $('#nav-col').removeClass('open-sidenav');
        $('#nav-col').addClass('close-sidenav');
      } else {
        $('#nav-col').removeClass('close-sidenav');
        $('#nav-col').addClass('open-sidenav');
      }
    });

    this.checkIfListScopeErrorExists();
    this.getSalaryDurationOptions();
    this.getAllPreferredJobTypes();
  }

  ngOnDestroy() {
    this.userDetailsSubscription.unsubscribe();
    this.logoutSubscription.unsubscribe();
  }

  private syncUserDetails() {
    this.userDetails = _.cloneDeep(this.authService.userDetails);
  }

  checkIfListScopeErrorExists() {
    this.userService.getLoggedInUserDetails((data) => {
      const clientLabel = this.authService.userDetails.company.companyType === 'Corporation' ? 'BU' : 'Client';
      // Both flags are true when the user's client/BU scope is 'List', the company has
      // child clients/BUs, and none of them is assigned to the user.
      if (data.isBUOrClientListEmptyForUser && data.isBUsOrClientsAvailable) {
        this.alertsAndNotificationsService.showBannerMessage(
          'You have a ' + clientLabel + ' Scope of \'List\' but no \'' + clientLabel + '\' is assigned to you.', 'danger');
      }
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  isStateWithData(): boolean {
    return STATES_WITH_DATA.includes(this.$state.current.name);
  }

  switchCompany() {
    if (this.isStateWithData()) {
      this.authService.setIsSwitchClicked(true);
      this.$state.go('missioncontrol.dashboard', null, { reload: true });
    } else {
      this.authService.setIsSwitchClicked(false);
      this.uibModalService.showAllCompanies();
    }
  }

  toggleSideNav() {
    $('#nav-col').toggleClass('close-sidenav');
  }

  showUserProfile(user) {
    this.$state.go('missioncontrol.usermanagement', {
      userId: user.id, accessMode: MESSAGECONSTANTS.ACCESS_MODES.EDIT, manager: null, purpose: 'view userprofile'
    }, { reload: false });
  }

  goToChangePassword() {
    this.$state.go('missioncontrol.changePassword', null, { reload: true });
  }

  goToNotificationPreferences() {
    this.$state.go('missioncontrol.notificationpreference', { userId: this.userDetails.id }, { reload: true });
  }

  logout(data?) {
    this.authService.setLogoutInProgress(true);
    if (this.authService.logoutDialog == null) {
      this.authService.setLogoutInProgress(false);
      this.authService.logoutDialog = bootbox.dialog({
        message: '<span class="loading-message"> Logging Out...<i class="fa fa-spinner fa-spin"></i></span>',
        closeButton: false
      });
    }
    this.webSocketsService.disconnect();
    this.webSocketsService.disconnectForChime();
    if (this.isStateWithData() && data !== undefined && data.logoutnow) {
      this.clearStorageForForcedLogout();
    }
    while (this.bsModalService.getModalsCount() > 0) {
      this.bsModalService.hide(this.bsModalService.getModalsCount());
    }
    this.StorageService.removeCookie('connect.sid', undefined);
    if (_.isNull(this.StorageService.get('companyDetails')) || _.isUndefined(this.StorageService.get('companyDetails'))) {
      this.StorageService.remove('companyDetails');
    }
    this.StorageService.remove('SelectedHostCompany');
    this.StorageService.remove('userDetails');
    if (!this.authService.isLogoutInProgress || this.authService.currentScreenHasSaveOption(this.$state.current.name)) {
      this.stateManagementStorageService.clear();
      this.$state.go('login', null, { reload: true });
      this.authService.logoutDialog.modal('hide');
    }
    setTimeout(() => {
      this.$state.reload();
    }, 100);
  }

  showNotifications() {
    this.userNotificationControls.notificationClickCount++;
    this.isNotificationClicked = !this.isNotificationClicked;
  }

  closeDropdown() {
    const dropdown = document.querySelector('.dropdown.open');
    if (dropdown) {
      dropdown.classList.remove('open');
    }
  }

  getSalaryDurationOptions() {
    this.jobService.getSalaryDurationOptions((data) => {
      this.salaryDurationOptions = data;
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getAllPreferredJobTypes() {
    this.jobService.getAllJobTypes((data) => {
      this.jobTypeList = data;
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  private clearStorageForForcedLogout() {
    const rememberMeStatus = _.cloneDeep(this.StorageService.getCookie('rememberme'));
    const userDetails = _.cloneDeep(this.StorageService.get('userDetails'));
    this.companyService.companyDeletedShowPopup = false;
    this.StorageService.resetBrowserStorage();
    if (rememberMeStatus === true && userDetails !== undefined && userDetails !== null) {
      this.StorageService.setCookie('logoutemail', userDetails.emailId, undefined);
    }
  }
}
